<template>
  <div id="contest-form" class="modal-form" v-if="formData">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <form class="formData-form">
            <div class="row">
              <div class="col-md-3">
                <input
                  type="submit"
                  class="btn btn-primary form-control"
                  value="SAVE & ACTIVATE"
                  @click="onSaveAndPublish"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                />
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary form-control"
                  @click="onUnpublish"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                >
                  DEACTIVATE
                </button>
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary form-control"
                  @click="onSaveDraft"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                >
                  Save
                </button>
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary close-button form-control"
                  @click="onClickCloseButton"
                >
                  Close
                </button>
              </div>
            </div>
            <h1 class="form-title">ADD/EDIT BADGE</h1>
            <fieldset>
              <legend>Basic information</legend>
              <div class="form-group row">
                <label for="title" class="form-label col-md-2"
                  >Reward Title*</label
                >
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    id="title"
                    required
                  />
                  <div class="invalid-feedback">Please enter a title.</div>
                </div>
              </div>
              <div class="form-group row">
                <label for="description" class="form-label col-md-2"
                  >Description*</label
                >
                <div class="col-md-10">
                  <textarea
                    type="text"
                    class="form-control"
                    id="description"
                    rows="4"
                  />
                  <div class="invalid-feedback">
                    Please enter a Description.
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for class="form-label col-md-2">Quantity* </label>
                <div class="col-md-4">
                  <input
                    type="number"
                    class="form-control"
                    placeholder="0 = unlimited"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="contest-type" class="form-label col-md-2"
                  >Type*</label
                >
                <div class="col-md-10 pt-0 pb-0">
                  <div class="row">
                    <div class="col-md-12 pb-0">
                      <div class="form-group form-check">
                        <input
                          type="radio"
                          class="form-check-input"
                          id="Check1"
                          value="most_likes"
                          style="margin-top: 8px"
                        />
                        <label class="form-check-label" for="Check1"
                          >Manual</label
                        >
                      </div>
                    </div>
                    <div class="col-md-3 pt-0 pb-0">
                      <div class="form-group form-check">
                        <input
                          type="radio"
                          class="form-check-input"
                          id="Check2"
                          value="select_by_jury"
                          style="margin-top: 8px"
                        />
                        <label class="form-check-label" for="Check2"
                          >Spending</label
                        >
                      </div>
                    </div>
                    <div class="col-md-5 pt-0 pb-0">
                      <div class="form-group form-check">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Enter amount"
                        />
                      </div>
                    </div>
                    <div class="col-md-4 pt-0 pb-0">
                      <div class="form-group form-check">
                        <select class="form-control">
                          <option value="">USD</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-3 pt-0 pb-0">
                      <div class="form-group form-check">
                        <input
                          type="radio"
                          class="form-check-input"
                          id="Check2"
                          value="select_by_jury"
                          style="margin-top: 8px"
                        />
                        <label class="form-check-label" for="Check2"
                          >Number of visits</label
                        >
                      </div>
                    </div>
                    <div class="col-md-5 pt-0 pb-0">
                      <div class="form-group form-check">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Enter quantity"
                        />
                      </div>
                    </div>
                    <div class="col-md-4 pt-0 pb-0"></div>
                    <div class="col-md-3 pt-0 pb-0">
                      <div class="form-group form-check">
                        <input
                          type="radio"
                          class="form-check-input"
                          id="Check2"
                          value="select_by_jury"
                          style="margin-top: 8px"
                        />
                        <label class="form-check-label" for="Check2"
                          >Activity</label
                        >
                      </div>
                    </div>
                    <div class="col-md-5 pt-0 pb-0">
                      <div class="form-group form-check">
                        <select class="form-control">
                          <option value="">Participate in campaign</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
            <fieldset>
              <legend>Badge</legend>
              <div>
                <ImageUploadButton
                  newColor="#681084"
                  ref="imageUploader"
                  :imageUrl="
                    formData.thumbnailUrl != '' ? formData.thumbnailUrl : ''
                  "
                  @clear="onClearUploadImage"
                />
              </div>
              <div>
                <ImageUploadButton
                  newColor="#681084"
                  ref="imageUploader"
                  :imageUrl="
                    formData.thumbnailUrl != '' ? formData.thumbnailUrl : ''
                  "
                  @clear="onClearUploadImage"
                />
              </div>
            </fieldset>
            <fieldset>
              <legend>Connections*</legend>
              <div class="form-group row">
                <div class="col-md-2">EXPERIENCES</div>
                <div class="col-md-10">
                  <table style="width: 100%" class="mb-1">
                    <thead>
                      <tr>
                        <th style="min-width: 250px">Experience Name</th>
                        <th>Status</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Bangkok Hotel Association</td>
                        <td>Confirmed</td>
                        <td><span class="underline">Edit</span></td>
                      </tr>
                      <tr>
                        <td>Experience Mekong Collection</td>
                        <td>Confirmed</td>
                        <td><span class="underline">Edit</span></td>
                      </tr>
                      <tr>
                        <td>Thailand Hotel Association</td>
                        <td>Requested</td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                  <AddContentButton color="#681084"
                    >ADD EXPERIENCE AFFILIATION</AddContentButton
                  >
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-2">campaigns</div>
                <div class="col-md-10">
                  <table style="width: 100%" class="mb-1">
                    <thead>
                      <tr>
                        <th style="min-width: 250px">Campaign Name</th>
                        <th>Status</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Feel Montolia</td>
                        <td>Confirmed</td>
                        <td><span class="underline">Edit</span></td>
                      </tr>
                    </tbody>
                  </table>
                  <AddContentButton color="#681084"
                    >ADD CAMPAIGN AFFILIATION</AddContentButton
                  >
                </div>
              </div>
              
            </fieldset>
            <fieldset>
              <legend>Distribution*</legend>
              <div class="form-group row">
                <div class="col-md-2"></div>
                <div class="col-md-10">
                  <table style="width: 100%" class="mb-1">
                    <thead>
                      <tr>
                        <th style="min-width: 250px">Channel Name</th>
                        <th>Status</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Mekong Moments</td>
                        <td>Confirmed</td>
                        <td><span class="underline">Edit</span></td>
                      </tr>
                      <tr>
                        <td>Inspiring Laos</td>
                        <td>Requested</td>
                        <td><span class="underline">Edit</span></td>
                      </tr>
                      <tr>
                        <td>Taste Thailand</td>
                        <td>Rejected</td>
                        <td><span class="underline">Edit</span></td>
                      </tr>
                    </tbody>
                  </table>
                  <AddContentButton color="#681084"
                    >ADD DISTRIBUTION CHANNEL</AddContentButton
                  >
                </div>
              </div>
            </fieldset>
            <div class="text-right">
                <a href="#" class="text-white underline">DELETE VOUCHER</a>
            </div>
            <div class="row">
              <div class="col-md-3">
                <input
                  type="submit"
                  class="btn btn-primary form-control"
                  value="SAVE & ACTIVATE"
                  @click="onSaveAndPublish"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                />
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary form-control"
                  @click="onUnpublish"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                >
                  DEACTIVATE
                </button>
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary form-control"
                  @click="onSaveDraft"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                >
                  Save
                </button>
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary close-button form-control"
                  @click="onClickCloseButton"
                >
                  Close
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
import ImageUploadButton from "@/components/ImageUploadButton";
import ExperiencePicker from "@/components/ExperiencePicker";
import PrizesControl from "@/components/PrizesControl";
import JuryControl from "@/views/Contests/Components/JuryForm";
import DateRangeControl from "@/components/DateRangeControl";
import EnwokeDeclarationFieldset from "@/components/EnwokeDeclarationFieldset";
import moment from "moment";
import AddContentButton from "@/components/AddContentButton";
import PlatformPicker from "@/components/PlatformPicker";
import _ from "lodash";

const defaultFormData = {
  
};

export default {
  name: "ContestForm",
  components: {
    ImageUploadButton,
    ExperiencePicker,
    PrizesControl,
    JuryControl,
    DateRangeControl,
    EnwokeDeclarationFieldset,
    AddContentButton,
    PlatformPicker,
  },
  props: {
    content: {
      type: Object,
    },
  },
  data() {
    return {
      id: null,
      regions: [],
      districts: [],
      options: [
        { text: "Content with most 'Likes' wins", value: "most_likes" },
        { text: "Winner is determined by a jury", value: "select_by_jury" },
      ],
      options1: [
        { text: "Once", value: "once" },
        { text: "Several times", value: "several times" },
        { text: "Daily", value: "daily" },
        { text: "Weekly", value: "weekly" },
        { text: "Monthly", value: "monthly" },
      ],
      options2: [
        { text: "Mondays", value: "monday" },
        { text: "Tuesdays", value: "tuesday" },
        { text: "Wednesday", value: "wednesday" },
        { text: "Thursdays", value: "thursday" },
        { text: "Fridays", value: "friday" },
        { text: "Saturdays", value: "saturday" },
        { text: "Sundays", value: "sunday" },
      ],
      formData: _.merge({}, defaultFormData),
    };
  },
  validations: {
    formData: {
      title: {
        required,
      },
      description: {
        required,
      },
    },
  },
  mounted() {
    if (this.content) {
      this.prepare(this.content);
    }
  },
  methods: {
    prepare(content) {
      const formData = _.merge(defaultFormData, content); // Create a copy.
      const m = moment(formData.announcementDate);
      if (formData.experiences && formData.experiences.results) {
        formData.experiences = formData.experiences.results;
      }

      if (formData.announcementDate != "") {
        formData.announcementDate = m.format("YYYY-MM-DD");
      }

      this.formData = formData;
      this.validateLocation(); // Re-validate to show country/region/district select box.
    },
    async uploadImages() {
      if (this.$refs.imageUploader) {
        return this.$refs.imageUploader.upload();
      } else {
        return null;
      }
    },
    onSubmit(ev) {
      ev.preventDefault();
    },
    onSaveAndPublish(ev) {
      this.save("PUBLISH");
    },
    onSaveDraft() {
      this.save("DRAFT");
    },
    onUnpublish() {
      this.save("UNPUBLISH");
    },
    async save(status = "PUBLISH") {
      if (status === "PUBLISH" && !this.formData.isAcceptedEnwokeAgreement)
        return;

      if (!this.formData.title || this.formData.title.trim() === "") {
        this.formData.title = "Untitled";
      }

      this.formData.status = status;

      const urls = await this.$refs.urls.uploadImages();
      urls.forEach((url, index) => {
        this.formData.prizes[index].images = [url];
      });

      this.formData.prizes.forEach((item, index) => {
        this.formData.prizes[index].value = parseFloat(item.value);
      });

      const files = await this.uploadImages();
      if (files && files.length > 0) {
        this.formData.mainImageUrl = files[0].url;
        this.formData.thumbnailUrl = files[0].url;
      }

      const date = this.$refs.date.value + " " + this.$refs.time.value;
      let dateString = "";
      if (date) {
        const m = moment(date);
        dateString = m.toJSON();
        this.formData.severalTimesOptions.closingDateOfFirstInstance = dateString;
      }

      if (this.formData.severalTimesOptions) {
        this.formData.severalTimesOptions.numberOfInstances = parseInt(
          this.formData.severalTimesOptions.numberOfInstances
        );
      }
      this.formData.daysVotingAfterSubmissionsClose = parseInt(
        this.formData.daysVotingAfterSubmissionsClose
      );
      this.formData.daysUntilAnnounceWinners = parseInt(
        this.formData.daysUntilAnnounceWinners
      );

      let promise = null;
      let saveData = _.merge({}, this.formData); // Clone data for saving.
      if (saveData.experiences && saveData.experiences.length > 0) {
        saveData.experiences = saveData.experiences.map((it) => it.id);
      }

      const dateAnnoun = new Date(this.formData.announcementDate);
      saveData.announcementDate = dateAnnoun.toJSON();
      // Finalize save data.
      // if (saveData.prizes && saveData.prizes.length > 0) {
      //   saveData.prizes.forEach(prizes => {
      //     if (prizes.items && prizes.items.length > 0) {
      //       prizes.items = prizes.items.map(it => ({
      //         title: "", // Placeholder for now
      //         sponsor: "", // Placeholder for now
      //         description: it.id,
      //         value: it.id,
      //         images: it.id,
      //       }));
      //     }
      //   });
      // }

      this.$v.$touch();
      if (!this.$v.$invalid || status != "PUBLISH") {
        if (this.formData.id) {
          promise = this.$repo.contest.updateContest(saveData);
        } else {
          promise = this.$repo.contest.createContest(saveData);
        }

        promise
          .then((experience) => {
            this.$toasted.show("Save data successfully.", {
              type: "success",
              duration: 3000,
              position: "bottom-right",
            });
            this.closeForm();
          })
          .catch((err) => {
            console.error(err);
            this.$toasted.show("Something went wrong.", {
              type: "error",
              duration: 3000,
              position: "bottom-right",
            });
          });
      }
    },
    async onDelete() {
      if (this.formData.id) {
        await this.$repo.contest.deleteContest(this.formData.id);
        this.closeForm();
      }
    },
    onClearUploadImage() {
      this.formData.mainImageUrl = "";
      this.formData.thumbnailUrl = "";
    },
    onClickCloseButton(ev) {
      ev.preventDefault();
      this.closeForm();
    },
    closeForm() {
      this.$emit("close");
    },
    onCountryChanged() {
      this.regions = [];
      this.districts = [];
      this.formData.region = null;
      this.formData.district = null;

      const countryId = this.formData.country;
      if (!countryId) return;

      const country = this.$store.state.ref.locations.find(
        (it) => it.id === countryId
      );
      if (country && country.children && country.children.length > 0) {
        this.regions = country.children;
        this.formData.region = this.regions[0].id; // Auto focus first item.
      }
    },
    onRegionChanged() {
      this.districts = [];
      this.formData.district = null;

      const regionId = this.formData.region;
      if (!regionId) return;

      const region = this.regions.find((it) => it.id === regionId);
      if (region && region.children && region.children.length > 0) {
        this.districts = region.children;
        //this.formData.district = this.districts[0].id; // Auto focus first item.
      }
    },
    validateLocation() {},
  },
};
</script>

<style lang="scss">
$main-color: #681084;

#contest-form {
  .form-title {
    color: $main-color;
  }

  .label-icon-box {
    background-color: #b9b9b9;
    color: #fff;
    display: inline-block;
    width: 40px;
    height: 40px;
    vertical-align: middle;
    margin-right: 10px;
    text-align: center;
    position: relative;

    .label-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .label-icon {
    font-size: 2rem;
  }

  #experience-form .form-title {
    color: $main-color;
  }

  input[type="submit"].btn-primary {
    background-color: $main-color;
    border-color: $main-color;
  }

  .experience-picker .vue-tags-input .ti-tag,
  .experience-picker .vue-tags-input .ti-selected-item,
  .picker-control li.selected {
    background-color: $main-color;
    border-color: $main-color;
  }

  .form-check-label {
    font-size: 14px;
  }

  .form-control {
    border-radius: 0;
  }

  .underline {
    cursor: pointer;
    text-decoration: underline;
  }
}
</style>
